"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.export.csv': 'Export CSV',
    'reports.export.excel': 'Export Excel',
};
